import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { NgForm } from '@angular/forms';
import { AuthService } from '../../../services/auth.service';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { FilenamePipe } from '../../../pipes/filename.pipe';

@Component({
	selector: 'app-gallery',
	templateUrl: './gallery.component.html',
	styleUrls: ['./gallery.component.scss']
})
export class GalleryComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('galleryForm', { static: true }) galleryForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	formSubscription: Subscription;
	formHeight: string;
	linkFocus;
	fallbackAnimation = Boolean(true);
	fallbackSingleImage = Boolean(false);
	fallbackSingleFirstImage = Boolean(true);
	selectedGroupIndex = Number(0);
	allowedDimensionsByFirstImg: string;
	arrowDimensionsLimitations: WidthLimitations = {
		max: 100,
		min: 46
	};
	isAdmin;
	invalidURLMarkerList = new Array();

	constructor(private cs: ComponentService, private auth: AuthService, private filenamePipe: FilenamePipe) {}

	ngOnInit() {
		if (!this.componentData.config.use_external) {
			this.componentData.config.use_external = {};
			this.componentData.config.use_external.image = false;
			this.componentData.config.use_external.add_image_tracking = false;
			this.componentData.config.use_external.link = false;
			this.componentData.config.use_external.add_link_tracking = false;
		}
		this.isAdmin = this.auth.isAdmin();

		this.setAllowedDimensions();

		if (
			!(
				this.componentData.config.fallback.use_first_image == '' ||
				this.componentData.config.fallback.use_first_image == false ||
				this.componentData.config.fallback.use_first_image == true
			)
		) {
			this.componentData.config.fallback.use_first_image = false;
			this.fallbackSingleFirstImage = false;
		}

		if (this.componentData.config.fallback.use_first_image == false && this.componentData.config.fallback.type == 'single_image') {
			this.fallbackSingleFirstImage = false;
		}

		this.formSubscription = this.galleryForm.valueChanges
			.pipe(
				tap(() => {
					this.cs.updateDisabledSave((this.galleryForm.dirty && this.galleryForm.invalid) || this.nameField.editComponentName);
					this.cs.updateComponentData(this.componentData);
				}),
				filter((data) => Boolean(this.galleryForm.dirty && this.galleryForm.valid)),
				debounceTime(1000)
			)
			.subscribe(
				(form) => {
					//          this.cs.updatePreviewData();
				},
				(error) => {
					// console.log(`PII: ${JSON.stringify(error)}`);
					this.cs.updateDisabledSave(false);
				},
				() => {}
			);
	}

	ngOnDestroy() {
		this.formSubscription.unsubscribe();
	}

	updateSave(type) {
		this.cs.updateDisabledSave(type);
	}

	setSingleFallbackImage(event) {
		if (this.fallbackSingleFirstImage == true) {
			this.componentData.config.fallback.image_url = this.componentData.config.images[0].src;
			this.componentData.config.fallback.use_first_image = true;
			this.cs.updateDisabledSave(false);
		} else {
			this.componentData.config.fallback.image_url = '';
			this.componentData.config.fallback.use_first_image = false;
			this.cs.updateDisabledSave(true);
		}
	}

	updateFallbackSingleImage(event): void {
		if (this.fallbackSingleFirstImage == true) {
			this.componentData.config.fallback.image_url = this.componentData.config.images[0].src;
		}
	}

	setAnimationFallbackImage(event): void {
		this.componentData.config.fallback.image_url = '';
		this.componentData.config.fallback.use_first_image = false;
		this.fallbackSingleFirstImage = true;
		this.cs.updateDisabledSave(false);
	}

	checkFallbackOption(): void {
		if (this.componentData.config.use_external.image == true) {
			this.fallbackSingleFirstImage = true;
			this.componentData.config.fallback.type = 'single_image';
			this.componentData.config.fallback.image_url = this.componentData.config.images[0].src;
			this.componentData.config.fallback.use_first_image = true;
		}
	}

	renderWidget(): void {
		this.cs.updateComponentData(this.componentData);
		this.cs.updatePreviewData();
	}

	onSwitchFallbackType(type: string): void {
		this.componentData.config.fallback.type = type;
	}

	addGalleryImage(event: MouseEvent): void {
		this.componentData.config.images.push({ src: '', url: '' });
	}

	removeGalleryImage(index: number): void {
		const imageName: string = this.filenamePipe.transform(
			String(this.componentData.config.images[index].src ? this.componentData.config.images[index].src : 'this image')
		);
		if (confirm(`Are sure you want to delete ${imageName}?`)) {
			this.componentData.config.images.splice(index, 1);
		}
	}

	onUploadSuccess({ url, index }) {
		this.componentData.config.images[index].src = url;
		if (this.componentData.config.fallback.type == 'single_image') {
			this.updateFallbackSingleImage(event);
		}
		if (index === 0) {
			this.setAllowedDimensions();
		}
	}

	setAllowedDimensions(): void {
		const firstImg: HTMLImageElement = new Image();
		firstImg.onload = () => {
			this.allowedDimensionsByFirstImg = String(`${firstImg.naturalWidth}x${firstImg.naturalHeight}`);
		};
		firstImg.src = this.componentData.config.images[0].src;
	}

	invalidURLMarker({ index, invalid }) {
		this.invalidURLMarkerList[index] = invalid;
	}
}

export interface WidthLimitations {
	max: number;
	min: number;
}
